<template>
    <v-card>
        <v-form ref="itemEditForm" v-model="formValid" :lazy-validation="true">
            <v-card-title v-if="!$props.fromSiteBook">Edit Item</v-card-title>
            <v-card-title v-if="$props.fromSiteBook">Node Item Details</v-card-title>

            <v-divider />

            <v-card-text>

                <v-text-field color="#c42111" outlined label="Item Name" v-model="$props.itemClone.item_name" :disabled="$props.fromSiteBook" :rules="[validation.required($props.itemClone.item_name)]" />

                <v-divider class="mb-8" />

                <v-row dense no-gutters>
                    <template v-for="itemField in itemFields">
                        <v-col cols="12" :key="itemField.object_field.field_id">
                            <v-text-field :label="itemField.object_field.field_name" color="#c42111" filled v-model="itemField.item_value" v-if="itemField.object_field.field_line_height == 1" :disabled="$props.fromSiteBook" />
                            <v-textarea :label="itemField.object_field.field_name" color="#c42111" filled v-model="itemField.item_value" :rows="itemField.object_field.field_line_height" v-if="itemField.object_field.field_line_height > 1" :disabled="$props.fromSiteBook" />
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text class="mr-3" @click="$emit('cancel')" v-if="!$props.fromSiteBook">Cancel</v-btn>
                <v-btn text class="mr-3" @click="$emit('close')" v-if="$props.fromSiteBook">Close</v-btn>
                <v-btn text class="mr-0" @click="okClick" v-if="!$props.fromSiteBook">Save</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
export default {
    name: 'ItemEdit',
    props: ['itemClone', 'itemFields', 'fromSiteBook'],
    components: {

    },
    data: () => ({
        formValid: true,
        validation: {
            required: (value) => (value ? true : false || "Required field")
        },
    }),

    computed: {
    },

    methods: {
        okClick: function() {
            if(this.$refs.itemEditForm.validate()) {
                this.$emit('save', this.$props.itemClone.item_name, this.$props.itemFields);
            }
        }
    },

    mounted() {

    }


};
</script>
